import type { FC, PropsWithChildren } from 'react'
import { Box, StackColumn } from '@dhl-ui/components'

export const FooterButtonsContainer: FC<PropsWithChildren> = ({ children }) => (
  <Box
    sx={{
      backgroundColor: (theme) => theme.palette.background.paper,
      borderTop: (theme) => `1px solid ${theme.palette.divider}`,
      padding: 2,
    }}
  >
    <StackColumn gap={2}>{children}</StackColumn>
  </Box>
)
